import Class from './c-actual';
import './c-actual@';

export default Class;